import Handlebars from 'handlebars';

import AssetAttachmentsTemplate from 'src/templates/AssetAttachments.handlebars.js';
import CollectionTemplate from 'src/templates/CollectionCard.handlebars';
import CollectionCTATemplate from 'src/templates/CollectionCTA.handlebars.js';
import CollectionLinkTemplate from "src/templates/CollectionLink.handlebars.js";

Handlebars.registerHelper('helperMissing', function() {
  var options = arguments[arguments.length - 1];
  return 'MISSING VALUE: ' + options.name;
}); 

Handlebars.registerHelper('placeholder', function(value, placeholder) {
  if(value !== undefined){
    return value;
  }

  var result = '<span class="placeholder">' + placeholder + '</span>';
  return new Handlebars.SafeString(result);
}); 

export default class CollectionWidgetManager{
  constructor() {
    this.widgets = [{
      id: 'company.logo',
      name: 'Company Logo',
      type: 'widget'
    },{
      id: 'company.branding',
      name: 'Company Branding',
      type: 'widget'
    },{
      id: 'company.name',
      name: 'Company Name',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['company.name'];
      }  
    },{
      id: 'collection.name',
      name: 'Collection Name',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['collection.name'];
      }
    },{
      id: 'collection.assets',
      name: 'Assets Count',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['collection.assets'];
      }
    },{
      id: 'contact.firstname',
      name: 'First Name',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['contact.firstname'];
      }
    },{
      id: 'contact.lastname',
      name: 'Last Name',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['contact.lastname'];
      }
    },{
      id: 'contact.company',
      name: 'Company',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['contact.company'];
      }
    },
    {
      id: 'signature.description',
      name: 'Signature',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['emailSignature'];
      }
    },
    {
      id: 'collection.card',
      name: 'Collection Card',
      type: 'widget',
      render: (node, parameters) => {
        if(node == null){
          node = document.createElement('div');
          node.classList.add('mceNonEditable', 'widget');
          node.setAttribute('data-widget-id', 'collection.card');
        }

        var html = CollectionTemplate(parameters);
        node.innerHTML = html;

        return node;
      }
    },{
      id: 'assets.grid',
      name: 'Assets Grid',
      type: 'widget',
    
      render: (node, parameters) => {
        const collectionCTA = document.querySelector(".widget.collectionCTA");

        if(node == null){
          node = document.createElement('div');
          node.classList.add('mceNonEditable', 'widget');
          node.setAttribute('data-widget-id', 'assets.grid');
          node.setAttribute('contenteditable', false);
        }
    
        let assets = parameters.assets || [];
        let isEmailTemplate = parameters.isEmailTemplate || false;
        let sections = parameters.sections || [];
        var html =  AssetAttachmentsTemplate(parameters);
    
        node.innerHTML = html;
        node.setAttribute('contenteditable', false);
    
        if (collectionCTA && collectionCTA.contains(node)) {
          collectionCTA.parentElement.insertBefore(node, collectionCTA.nextSibling);
        }
    
        return node;
      },

      convertToTemplate(node){
        if(!node){
          return;
        }

        var anchorNodes = node.querySelectorAll('a[data-widget-placeholder]');
  
        if(anchorNodes && anchorNodes.length > 0){
          for (var i = 0; i < anchorNodes.length; i++) {
            var element = anchorNodes[i];
            var shareIndex= element.getAttribute('data-index');
            var isSectionCollection = element.getAttribute('data-widget-assetType');
            var placeholder=null;
            if (isSectionCollection) {
              placeholder = "\{{contact.url}}/collections/\{{share.id}}"
            } else {
              placeholder = `\{{contact.url}}/collections/\{{share.id}}/a/\{{share.assets.[${shareIndex}].id}}`
            }    
            
            element.setAttribute('href', placeholder);
            element.removeAttribute('data-widget-placeholder');
          }
        }

        var imgNodes = node.querySelectorAll('img[data-widget-placeholder]');
  
        if(imgNodes && imgNodes.length > 0){
          for (var i = 0; i < imgNodes.length; i++) {
            var element = imgNodes[i];
              placeholder = `\{{apiUrl}}/shared_url/\{{share.id}}/asset/\{{share.assets.[${i}].id}}/icon`
            element.src = placeholder;
            element.removeAttribute('data-widget-placeholder');
          }
        }
      }
    },{
      id: 'asset.card',
      name: 'Asset Card',
      type: 'widget',
      template: '',
      render: (node, parameters) => {
          
      }
    },{
      id: 'collection.cta',
      name: 'Collection CTA',
      type: 'widget',

      render: (node, parameters) => {
        
        if(node == null){
          node = document.createElement('div');
          node.classList.add('widget', 'collectionCTA');
          node.setAttribute('data-widget-id', 'collection.cta');
          
          var html =  CollectionCTATemplate(parameters);
          node.innerHTML = html;          
        }

        return node;
      },

      convertToTemplate(node){

        if(!node){
          return;
        }

        var anchorNodes = node.querySelectorAll('a[data-widget-placeholder]');
  
        if(anchorNodes && anchorNodes.length > 0){
          for (var i = 0; i < anchorNodes.length; i++) {
            var element = anchorNodes[i];
            var placeholder = `{{contact.url}}/collections/{{share.id}}`;
            element.setAttribute('href', placeholder);
            element.removeAttribute('data-widget-placeholder');
          }
        }
      }
    },{
      id: 'collection.link',
      name: 'Collection Link',
      type: 'widget',

      render: (node, parameters) => {
        if(node == null){
          node = document.createElement('div');
          node.classList.add('widget', 'collectionLink');
          node.setAttribute('data-widget-id', 'collection.link');
        
          var html =  CollectionLinkTemplate(parameters);
          node.innerHTML = html;
        }
        
        return node;
      },

      convertToTemplate(node){
        if(!node){
          return;
        }

        var anchorNodes = node.querySelectorAll('a[data-widget-placeholder]');
  
        if(anchorNodes && anchorNodes.length > 0){
          for (var i = 0; i < anchorNodes.length; i++) {
            var element = anchorNodes[i];
            var placeholder = `\{{contact.url}}/collections/\{{share.id}}`;
            element.setAttribute('href', placeholder);
            element.removeAttribute('data-widget-placeholder');
          }
        }
      }
    },{
      id: 'signature.description',
      name: 'Signature Description',
      type: 'widget',
      render: (node, parameters) => {
        if(node == null){
          node = document.createElement('div');
          var html = parameters.emailSignature;
          node.innerHTML = html;
        }
        
        return node;
      }
    }];
  }

  variables(){
    return this.widgets.filter((item) => {
      return item.type == 'variable'
    })
  }

  variable(id){
    return this.widgets.find((item) => {
      return item.id == id && item.type == 'variable';
    })  
  }

  widgets(){
   return this.widgets.filter((item) => {
      return item.type == 'widget'
    }) 
  }

  widget(id){
    return this.widgets.find((item) => {
      return item.id == id && item.type == 'widget';
    })  
  }

  render(template, parameters, showPlaceholders){
    if(showPlaceholders){
      template = this.processHandlebarTemplate(template);  
    }

    var compiledTemplate = Handlebars.compile(template, {knownHelpersOnly: false, strict: false, assumeObjects: true});
    var html = compiledTemplate(parameters);

    return html;
  }

  getRawTemplate(html){
    var node = document.createElement('div');
    node.innerHTML = html;

    var variableNodes = node.querySelectorAll('.variable[data-original-variable]');
  
    if(variableNodes && variableNodes.length > 0){
      for (var i = 0; i < variableNodes.length; i++) {
        var element = variableNodes[i];

        var nodeValue = element.getAttribute('data-original-variable');
        var div = document.createElement('div');

        var appliedStyle = element.getAttribute("style");
        if(appliedStyle){
          var span = document.createElement('span');
          span.setAttribute('style', appliedStyle);
          span.innerHTML = nodeValue;

          div.appendChild(span);
        }else{
          div.innerHTML = nodeValue;  
        }
        
        var child;
        while ((child = div.lastChild)) {
          element.parentNode.insertBefore(child, element.nextSibling);
        }

        // remove HTML variable node
        // because we now have an text representation of the variable
        element.parentNode.removeChild(element);
      }
    }

    var widgetNodes = node.querySelectorAll('.widget[data-widget-id]');
  
    if(widgetNodes && widgetNodes.length > 0){
      for (var i = 0; i < widgetNodes.length; i++) {
        var element = widgetNodes[i];

        var widgetID = element.getAttribute('data-widget-id');
        var widget = this.widget(widgetID);

        if(widget){
          widget.convertToTemplate(element);
        }
      }
    }
    
    return node.innerHTML;
  }

  isWidgetInserted(html) {
    var node = document.createElement('div');
    node.innerHTML = html;

    var widgetNodes = node.querySelectorAll('.widget[data-widget-id]');

    return widgetNodes.length > 0;
  }

  processHandlebarTemplate(html){
    var node = document.createElement('div');
    node.innerHTML = html;

    var walkDOM = function (node,func) {
      func(node);
      node = node.firstChild;
      while(node) {
          walkDOM(node,func);
          node = node.nextSibling;
      }
    };    

    var manager = this;
    var stringVariableRegex = new RegExp('{{' + '([a-z. _]*)?' + '}}', 'g');
    var nodeList = [];

    walkDOM(node, (n) => {
      if (n.nodeType == 3 && n.nodeValue && stringVariableRegex.test(n.nodeValue)) {
        nodeList.push(n);
      }
    });

    for (var i = 0; i < nodeList.length; i++) {
      var element = nodeList[i];
      var nodeValue = nodeList[i].nodeValue;

      nodeValue = nodeList[i].nodeValue.replace(stringVariableRegex, function(value){
        var cleanValue = value.replace(/[^a-zA-Z0-9._]/g, "");
        
        var variable = manager.variable(cleanValue);
        if(variable){
          return '{{placeholder ' + cleanValue + ' ' + '"'+ variable.name +'"}}'
        }

        return '\\{{' + cleanValue + '}}';
      });

      var div = document.createElement('div');
      div.innerHTML = nodeValue;

      var child;
      while ((child = div.lastChild)) {
          element.parentNode.insertBefore(child, element.nextSibling);
      }

      element.parentNode.removeChild(element);
    }


    return node.innerHTML;
  }
}
